import PanToolIcon from '@mui/icons-material/PanTool';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import {
  Badge,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Divider,
  FormControlLabel,
  FormGroup,
  IconButton,
  MenuItem,
  Paper,
  Select,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Toolbar,
  Tooltip,
  Typography,
} from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import AxiosConfig from '../../../config/AxiosConfig';
import TicketStatusChip from '../utils/common/TicketStatusChip.jsx';

const headers = [
  {
    id: 'reference',
    align: 'left',
    label: 'Référence',
  },
  {
    id: 'follow',
    align: 'left',
    label: 'Suivi',
  },
  {
    id: 'status',
    align: 'left',
    label: 'Status',
  },
  {
    id: 'order',
    align: 'left',
    label: 'N° Commande',
  },
  {
    id: 'contact',
    align: 'left',
    label: 'Contact',
  },
  {
    id: 'store',
    align: 'left',
    label: 'Store',
  },
  // {
  //   id: "categorization",
  //   align: "left",
  //   label: "Catégorie",
  // },
  // {
  //   id: "priority",
  //   align: "left",
  //   label: "Priorité",
  // },
  {
    id: 'messages',
    align: 'left',
    label: 'Message(s)',
  },
  {
    id: 'lastMessageAt',
    align: 'left',
    label: 'Dernier message',
  },
  {
    id: 'snippet',
    align: 'left',
    label: 'Snippet',
  },
  {
    id: 'actions',
    align: 'right',
    label: '',
  },
];
// TODO : rajouter status / lastmessageat / priorité

const InboxTicketsTableToolbar = (props) => {
  const {
    loading,
    validating,
    nb,
    inboxData,
    setAssignedTypeTicket,
    setStatus,
    setIsClose,
    setToModerate,
    setSellerType,
    setHasNewResponse,
  } = props;

  const status = [
    {
      name: 'Actif',
      code: 0,
    },
    {
      name: 'En attente',
      code: 1,
    },
    {
      name: 'Traité',
      code: 2,
    },
  ];

  const handleAssignedTypeTicketCheckbox = useCallback(() => {
    if (inboxData?.assignedTypeTicket === true) {
      setAssignedTypeTicket(false); // Passe à "Suivis par moi"
    } else if (inboxData?.assignedTypeTicket === false) {
      setAssignedTypeTicket(null); // Passe à "Liés à moi"
    } else {
      setAssignedTypeTicket(true); // Passe à "Assignés à moi"
    }
  }, [setAssignedTypeTicket, inboxData?.assignedTypeTicket]);

  const handleStatusSelectChange = (e, _value) => {
    setStatus(e.target.value);
  };

  const handleIsCloseCheckbox = (_e) => {
    setIsClose(!inboxData?.isClose);
    setToModerate(false);
    setHasNewResponse(false);
    setStatus(2);
  };

  const handleToModerateCheckbox = (_e) => {
    setToModerate(!inboxData?.toModerate);
    setHasNewResponse(false);
    setStatus(0);
  };

  const handleSellerTypeCheckbox = (_e) => {
    if (inboxData?.sellerType === null) {
      setSellerType(true);
    }
    if (inboxData?.sellerType === true) {
      setSellerType(false);
    }
    if (inboxData?.sellerType === false) {
      setSellerType(null);
    }
  };

  const handleHasNewResponseCheckbox = (_e) => {
    setHasNewResponse(!inboxData?.hasNewResponse);
    setStatus(0);
  };

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      <Typography
        component={'span'}
        sx={{ flex: '1 1 100%' }}
        variant="h6"
        id="tableTitle"
      >
        Tickets à traiter :{' '}
        {loading || validating ? (
          <CircularProgress color="info" size={'0.8em'} />
        ) : (
          nb
        )}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          whiteSpace: 'nowrap',
          justifyContent: 'space-around',
          alignItems: 'center',
          width: '100%',
        }}
      >
        {inboxData?.assignedTypeTicket !== undefined && (
          <FormControlLabel
            control={
              <Checkbox
                size="small"
                checked={inboxData?.assignedTypeTicket === true}
                indeterminate={inboxData?.assignedTypeTicket === null}
                onChange={handleAssignedTypeTicketCheckbox}
                aria-label="Filtre d'assignation"
              />
            }
            label={
              inboxData?.assignedTypeTicket === true
                ? 'Assignées à moi'
                : inboxData?.assignedTypeTicket === false
                  ? 'Suivis par moi'
                  : 'Liées à moi'
            }
          />
        )}
        {inboxData?.sellerType !== undefined ? (
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={inboxData?.sellerType === true}
                  indeterminate={inboxData?.sellerType === false}
                  onChange={handleSellerTypeCheckbox}
                  disabled={inboxData?.toModerate}
                />
              }
              label={
                inboxData?.sellerType === true
                  ? 'Marketplace seulement'
                  : inboxData?.sellerType === false
                    ? 'Hoortrade seulement'
                    : 'Tout revendeur'
              }
            />
          </FormGroup>
        ) : null}
        {inboxData?.isClose !== undefined ? (
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={inboxData?.isClose}
                  onChange={handleIsCloseCheckbox}
                  disabled={inboxData?.toModerate}
                />
              }
              label="Fermé"
            />
          </FormGroup>
        ) : null}
        {inboxData?.toModerate !== undefined ? (
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={inboxData?.toModerate}
                  onChange={handleToModerateCheckbox}
                  disabled={inboxData?.isClose}
                />
              }
              label="Modération"
            />
          </FormGroup>
        ) : null}
        {inboxData?.hasNewResponse !== undefined ? (
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={inboxData?.hasNewResponse}
                  onChange={handleHasNewResponseCheckbox}
                  disabled={inboxData?.isClose || inboxData?.toModerate}
                />
              }
              label="Nouvelle réponse"
            />
          </FormGroup>
        ) : null}
        {inboxData?.status !== undefined ? (
          <FormGroup>
            <FormControlLabel
              control={
                <Select
                  labelId="select-status-to-filter"
                  id="select-status-to-filter"
                  value={
                    status?.find((elem) => elem.code === inboxData?.status)
                      ?.code
                  }
                  onChange={handleStatusSelectChange}
                  sx={{ width: '95%', margin: 1 }}
                  size="small"
                  disabled={
                    inboxData?.isClose ||
                    inboxData?.hasNewResponse ||
                    inboxData?.toModerate
                  }
                >
                  {status?.map((status, idx) => {
                    return (
                      <MenuItem key={idx} value={status?.code}>
                        <Typography>{status?.name}</Typography>
                      </MenuItem>
                    );
                  })}
                </Select>
              }
              label="Statut"
              labelPlacement="start"
            />
          </FormGroup>
        ) : null}
      </Box>
    </Toolbar>
  );
};

const InboxTicketsTableHead = (props) => {
  const { inboxData, setOrderBy, setOrder } = props;

  const handleChangeOrder = (orderBy) => {
    if (inboxData?.orderBy === orderBy) {
      switch (inboxData?.order) {
        case 'asc':
          setOrder('desc');
          break;
        case 'desc':
          setOrderBy(null);
          break;
        default:
          setOrder('asc');
      }
    } else {
      setOrderBy(orderBy);
      setOrder('asc');
    }
  };

  return (
    <TableHead>
      <TableRow>
        {headers?.map((header) => (
          <TableCell
            key={header?.id}
            align={header?.align}
            sortDirection={
              inboxData?.orderBy === header?.id ? inboxData?.order : false
            }
          >
            {header?.id === 'status' || header?.id === 'lastMessageAt' ? (
              <>
                <TableSortLabel
                  active={inboxData?.orderBy === header?.id}
                  direction={
                    inboxData?.orderBy === header?.id ? inboxData?.order : 'asc'
                  }
                  onClick={(_e) => handleChangeOrder(header?.id)}
                >
                  {header?.label}
                  {inboxData?.orderBy === header?.id ? (
                    <Box component="span" sx={visuallyHidden}>
                      {inboxData?.order
                        ? inboxData?.order === 'desc'
                          ? 'sorted descending'
                          : 'sorted ascending'
                        : null}
                    </Box>
                  ) : null}
                </TableSortLabel>
              </>
            ) : (
              <>{header?.label}</>
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
const InboxTicketRow = ({ ticket, mutate }) => {
  const navigate = useNavigate();
  const profile = useSelector((state) => state?.login?.profile);
  const [isFollowed, setIsFollowed] = useState(false);
  useEffect(() => {
    setIsFollowed(ticket?.observers?.some((obs) => obs?._id === profile._id));
  }, [ticket, profile]);
  const handleNavigateToProject = (projectId, ticketId) => {
    navigate(`/project/${projectId}/tickets/${ticketId}/activities`);
  };
  const cancelModeration = (ticketId) => {
    AxiosConfig.create('post', `/tickets/${ticketId}/cancelModeration`)
      .call()
      .exit((_res) => {
        mutate();
      })
      .catch((err) => console.error(err));
  };
  const toggleFollow = async () => {
    try {
      setIsFollowed((prev) => !prev);
      const response = await AxiosConfig.create(
        'post',
        `/tickets/${ticket?._id}/toggleFollow`
      ).call({ userId: profile?._id });
      if (response !== null) {
        setIsFollowed(response);
      }
      mutate();
    } catch (error) {
      console.error('Erreur lors du suivi du ticket', error);
      setIsFollowed((prev) => !prev);
    }
  };
  return (
    <TableRow
      hover
      tabIndex={-1}
      key={ticket?._id}
      sx={{
        cursor: 'pointer',
      }}
      value={ticket?._id}
    >
      <TableCell>
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={(_e) =>
            handleNavigateToProject(ticket?.project?._id, ticket?._id)
          }
          sx={{
            margin: 0,
            whiteSpace: 'nowrap',
            minWidth: 'auto',
          }}
        >
          {ticket?.reference}
        </Button>
      </TableCell>
      <TableCell>
        <Tooltip title={isFollowed ? 'Ne plus suivre' : 'Suivre'}>
          <IconButton
            onClick={toggleFollow}
            size="small"
            color={isFollowed ? 'warning' : 'default'}
          >
            {isFollowed ? <StarIcon /> : <StarBorderIcon />}
          </IconButton>
        </Tooltip>
      </TableCell>
      <TableCell>
        <TicketStatusChip
          status={ticket?.status}
          hasActiveTask={ticket?.hasActiveTask}
          isOpen={ticket?.isOpen}
        />
      </TableCell>
      <TableCell>
        {ticket?.order ? ticket?.order?.reference : 'N./A.'}
      </TableCell>
      <TableCell>
        <Tooltip placement="top" title={ticket?.contact?.email}>
          <Typography component={'span'}>
            {ticket?.contact?.firstName !== null &&
            ticket?.contact?.lastName !== null
              ? `${ticket?.contact?.firstName} ${ticket?.contact?.lastName}`
              : ticket?.contact?.lastName !== null
                ? `${ticket?.contact?.lastName}`
                : `${ticket?.contact?.email}`}
          </Typography>
        </Tooltip>
      </TableCell>
      <TableCell>{ticket?.contact?.store?.shortName}</TableCell>
      {/* <TableCell>
        <TicketTypeIcon
          ticketType={ticket?.ticketType?.name}
          service={ticket?.service?.code}
        />
      </TableCell> */}
      {/* <TableCell>
        <PriorityFlag priority={ticket?.priority?.name} />
      </TableCell> */}
      <TableCell
        sx={{
          textAlign: 'left',
        }}
      >
        {ticket?.hasNewResponse ? (
          <Badge color="error" badgeContent={ticket?.messagesCount}></Badge>
        ) : (
          <>{ticket?.messagesCount}</>
        )}
      </TableCell>
      <TableCell>
        {ticket?.lastMessageAt
          ? new Date(ticket?.lastMessageAt).toLocaleString('fr-FR', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
            })
          : 'Pas de message'}
      </TableCell>
      <TableCell>
        <Tooltip
          placement="left"
          title={
            <Box>
              {new Date(ticket?.message?.sentAt).toLocaleString('fr-FR', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
              })}
              <Divider />
              <Typography
                component={'span'}
                sx={{
                  fontSize: '0.7rem',
                  whiteSpace: 'break-spaces',
                }}
              >
                {ticket?.message?.snippet}
              </Typography>
            </Box>
          }
        >
          <Typography
            component={'span'}
            sx={{
              fontSize: '0.9rem',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitLineClamp: '2',
              WebkitBoxOrient: 'vertical',
            }}
          >
            {ticket?.message?.snippet}
          </Typography>
        </Tooltip>
      </TableCell>

      <TableCell align="right">
        <Box
          sx={{
            display: 'flex',
            alignItems: 'right',
            justifyContent: 'space-around',
          }}
        >
          {ticket?.toModerate ? (
            <>
              <Tooltip placement="top" title={'Modération demandée'}>
                <PanToolIcon
                  id={ticket?._id}
                  onClick={(_e) => cancelModeration(ticket?._id)}
                />
              </Tooltip>
            </>
          ) : null}
        </Box>
      </TableCell>
    </TableRow>
  );
};

const InboxTicketTable = (props) => {
  const {
    datas,
    loading,
    validating,
    inboxData,
    limit,
    setLimit,
    page,
    setPage,
    setAssignedTypeTicket,
    setStatus,
    setIsClose,
    setToModerate,
    setSellerType,
    setHasNewResponse,
    setOrderBy,
    setOrder,
    total,
    mutate,
  } = props;

  const handleChangePage = useCallback(
    (event, newPage) => {
      setPage(newPage);
    },
    [limit, datas]
  );

  const handleChangeLimit = useCallback(
    (event) => {
      const updatedLimit = parseInt(event.target.value, 10);
      setLimit(updatedLimit);
      setPage(0);
    },
    [datas]
  );

  return (
    <Paper elevation={24} sx={{ width: '100%', mb: 2 }}>
      <InboxTicketsTableToolbar
        loading={loading}
        validating={validating}
        nb={total}
        inboxData={inboxData}
        setAssignedTypeTicket={setAssignedTypeTicket}
        setStatus={setStatus}
        setIsClose={setIsClose}
        setToModerate={setToModerate}
        setSellerType={setSellerType}
        setHasNewResponse={setHasNewResponse}
      />
      <TableContainer>
        <Table
          sx={{ minWidth: 750 }}
          // aria-labelledby="tableTitle"
          size="small"
        >
          <InboxTicketsTableHead
            inboxData={inboxData}
            setOrderBy={setOrderBy}
            setOrder={setOrder}
          />
          <TableBody>
            {loading ? (
              <TableRow>
                {headers?.map((h, idx) => (
                  <TableCell key={idx}>
                    <Skeleton variant="text" sx={{ fontSize: '2em' }} />
                  </TableCell>
                ))}
              </TableRow>
            ) : datas ? (
              datas?.map((row) => {
                return row?.reference ? (
                  <InboxTicketRow key={row?._id} ticket={row} mutate={mutate} />
                ) : (
                  <TableRow>
                    {headers?.map((h, idx) => (
                      <TableCell key={idx}>
                        <Skeleton variant="text" sx={{ fontSize: '2em' }} />
                      </TableCell>
                    ))}
                  </TableRow>
                );
              })
            ) : null}
          </TableBody>
        </Table>
      </TableContainer>
      {datas ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
          }}
        >
          {validating && <CircularProgress color="info" size={'1.3em'} />}
          <TablePagination
            rowsPerPageOptions={[10]}
            component="div"
            count={total}
            rowsPerPage={limit}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeLimit}
          />
        </Box>
      ) : null}
    </Paper>
  );
};

export default InboxTicketTable;
